import mod from "-!./Owners.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Owners.js?vue&type=script&lang=js&external"